const { Component, render, findDOMNode, Fragment } = wp.element;

const alias = 'SliderBerg-Slider-';

import {
  SliderBerg_isset as isset,
  SliderBerg_GoogleFontLoader as GoogleFontUploader
} from './utils.js';
import { object } from 'prop-types';

class SliderBerg_Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: false,
      elapsed_time: 0,
      isPaused: false,
      displayText: ''
    };

    const { items } = this.props;
    if (items.length > 0) {
      this.state.selected = items[0];
    }

    if (isset(this.props.options, 'autoplay') && !this.props.options.autoplay) {
      this.state.isPaused = true;
    }

    if (!isset(this.props.options, 'slider_height')) {
      this.props.options = 350;
    }

    this.mainInterval = null;
  }

  componentDidMount() {
    const interval = 10;

    let scale = 1;
    let scale_step = 0.001;


    this.mainInterval = setInterval(() => {

      if (!this.state.isPaused) {
        scale_step = 10/this.props.options.slide_timeout;

        if (this.state.elapsed_time >= this.props.options.slide_timeout) {
          this.goToSlide();
          scale = 1;
        }

        scale = scale + scale_step;


        this.setState({
          elapsed_time: this.state.elapsed_time + interval
        });

        this.refs.current_image.style.transform = `scale(${scale})`
      }
    }, interval);
  }

  // onMouseOver(e) {
  //   if (this.props.options.autostop) this.setState({ isPaused: true });
  // }

  // onMouseOut(e) {
  //   if (this.props.options.autostop) this.setState({ isPaused: false });
  // }

  buildSliderItems() {
    const { items } = this.props;
    const { text_align, show_text, text_size, text_font, pag_color } = this.props.options;
    const { selected } = this.state;

    let textStyle = {};
    if (text_align === 'left') {
      textStyle = {
        left: '40px',
        backgroundColor: this.props.options.text_bg_color
      };
    } else if (text_align === 'right') {
      textStyle = {
        right: '80px',
        position: 'absolute',
        backgroundColor: this.props.options.text_bg_color
      };
    } else if (text_align === 'center') {
      textStyle = {
        left: '50%',
        transform: 'translate(-50%, 0%)',
        backgroundColor: this.props.options.text_bg_color
      };
    }

    let textStyleCustom = {};
    if (text_align === 'left') {
      textStyleCustom = {
        left: '40px',

      };
    } else if (text_align === 'right') {
      textStyleCustom = {
        right: '40px',
        left: 'auto',
        position: 'absolute'

      };
    } else if (text_align === 'center') {
      textStyleCustom = {
        left: '47%',
        transform: 'translate(-47%, 0%)',
      };
    }

    return items.map((object_key, index) => {
      const item = items[index];
      return (
        <li
          key={index}
          style={{
            zIndex: selected == object_key ? 88 : 1
          }}
        >
          <a href={item.url} className={`${alias}main-image`}>
            <img
              ref={ selected == object_key ? 'current_image' : '' }
              src={item.image.replace(':5360', '')}
              style={{
                //transform: `${selected == object_key ? 'scale(1.8)' : 'scale(1)'}`,
                //transition: `transform 1ms cubic-bezier(0.420, 0.000, 1.000, 1.000)`
              }}
            />
          </a>
          {show_text ? (
            <Fragment>
              <div className="slider-pagination">
                <h2 style={textStyle}>
                  <a className="first"
                    href={item.url}
                    style={{
                      fontSize: `${text_size}px`,
                      color: this.props.options.text_color,
                      fontFamily: text_font,
                      lineHeight: `${text_size}px`
                    }}
                  >
                    {item.title}
                  </a>
                </h2>
                <p style={textStyleCustom}>
                  <a className="second"
                    style={{
                      backgroundColor: '#000',
                      color: '#fff',
                      lineHeight: `${text_size}px`,
                      fontSize: `${text_size}px`,
                    }}
                  >{`${index + 1}/${items.length}`}</a>
                </p>
              </div>
            </Fragment>
          ) : (
            ''
          )}

        </li>
      );
    });
  }

  goToSlide(where = 'next') {
    const { items } = this.props;
    const { selected } = this.state;

    const current_index = items.indexOf(selected);
    let next_index = -1;

    if (where == 'next') {
      next_index = current_index + 1;
      if (current_index >= items.length - 1) {
        next_index = 0;
      }
    } else if (where == 'prev') {
      next_index = current_index - 1;
      if (current_index <= 0) {
        next_index = items.length - 1;
      }
    }
    this.setState({
      selected: items[next_index],
      elapsed_time: 0
    });
  }

  buildNav() {
    const { isPaused } = this.state;

    return (
      <div className={`${alias}nav`}>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            this.goToSlide('prev');
          }}
        >
          <span class="dashicons dashicons-arrow-left-alt2" />
        </a>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            this.setState({ isPaused: !this.state.isPaused });
          }}
        >
          {isPaused ? <span class="dashicons dashicons-controls-play" /> : ''}
          {!isPaused ? <span class="dashicons dashicons-controls-pause" /> : ''}
        </a>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            this.goToSlide('next');
          }}
        >
          <span class="dashicons dashicons-arrow-right-alt2" />
        </a>
      </div>
    );
  }

  buildNextTimer() {
    const { pag_color } = this.props.options;
    const marker_width = (this.state.elapsed_time * 100) / this.props.options.slide_timeout;
    return (
      <span
        className={`${alias}timer`}
        style={{
          width: `${marker_width}%`,
          backgroundColor: pag_color
        }}
      />
    );
  }

  buildPag() {
    const { selected } = this.state;
    const { items } = this.props;
    const { pag_bg_color } = this.props.options;

    return (
      <div
        className={`${alias}pag`}
        style={{
          gridTemplateColumns: `repeat(${items.length}, 1fr)`
        }}
      >
        {items.map((object_key, index) => {
          return (
            <div
              style={{
                backgroundColor: pag_bg_color
              }}
              onClick={() => this.setState({ selected: object_key, elapsed_time: 0 })}
            >
              {object_key == selected ? this.buildNextTimer() : ''}
            </div>
          );
        })}
      </div>
    );
  }

  buildMainText() {
    const { items } = this.props;
    const { selected } = this.state;
    const { main_text_size } = this.props.options;

    return (
      <div className={`${alias}main-text`}>
        {items.map((item, index) => {
          return (
            <Fragment>
              <h3
                style={{
                  zIndex: selected == item ? 88 : 1,
                  display: selected == item ? 'block' : 'none',
                  backgroundColor: this.props.options.text_bg_color,
                  borderLeftColor: this.props.options.pag_bg_color,
                  lineHeight: `${main_text_size}px`
                }}
              >
                <a
                  href={item.url}
                  style={{
                    color: this.props.options.text_color,
                    fontFamily: this.props.options.text_font,
                    fontSize: `${main_text_size}px`
                  }}
                >
                  {item.mainText}
                </a>
              </h3>
              <h5
                style={{
                  zIndex: selected == item ? 88 : 1
                }}
                className={`${alias}read-more`}
              >

              <a
                href={item.url}
                  style={{
                    fontFamily: this.props.options.text_font

                  }}
                >
                  Read More
                </a>


              </h5>
            </Fragment>
          );
        })}
      </div>
    );
  }

  render() {
    const { items } = this.props;
    const { show_nav, show_pag, slider_height, show_text } = this.props.options;

    return (
      <div
        className={`${alias}wrapper`}
        style={{
          height: `${parseInt(slider_height)}px`
        }}
        // onMouseOver={this.onMouseOver.bind(this)}
        // onMouseOut={this.onMouseOut.bind(this)}
      >
        <ul>
          {items.length ? (
            <Fragment>
              {show_nav ? this.buildNav() : ''}
              {show_pag ? this.buildPag() : ''}
              {this.buildSliderItems()}
            </Fragment>
          ) : (
            ''
          )}
        </ul>
        <div className={`${alias}text-area`}>{show_text ? this.buildMainText() : ''}</div>
      </div>
    );
  }
}

export { SliderBerg_Slider };



// WEBPACK FOOTER //
// ./src/js/slider.js